module.exports = __webpack_public_path__ + "static/media/jurusan-kelas.edd37e3d.png";